import React, { useState, useEffect, useCallback } from "react";
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { ThemeProvider } from '@mui/styles';
import MaterialTable from "material-table";
import { createTheme } from '@mui/material';
import {ACCOUNT_ICON,CALENDER_ICON ,EDIT_ICON, TRASH_ICON,} from "assets/constants/Icons";
import "./user-style.css";
import moment from 'moment';
import { hasPermission } from 'components/Permission';
import { getPricingList,deletePricingModelCall } from "lib/axiosUtils";
import { useHistory } from "react-router-dom";
import ShowToast from 'components/ShowToast';
import Spinner from 'components/Spinner';

const PricingModelPage = () => {
    const history = useHistory();
    const [pricingModel, setPricingModel] = useState([]);
    const [tableActionsArray, setTableActionsArray] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [metaData, setMetaData] = useState([]);

  useEffect(() => {
    if(metaData.length === 0){
    const getMetadata =  () => {
        const storedMetadata = localStorage.getItem("metadata");
        if (storedMetadata) {
          console.log("metadata from localStorage::", storedMetadata);
          return JSON.parse(storedMetadata);
        } else {
          console.warn("No metadata found in localStorage");
          return null;
        }
    };
    const resultmetadata =  getMetadata();
    setMetaData(resultmetadata);}
  },[metaData])

  const fetchPricingList = useCallback(async () => {
    try {
        const data = await getPricingList({}, {});

        if (!metaData || metaData.length === 0) {
          const storedMeta = localStorage.getItem("metadata");
          if (storedMeta) setMetaData(JSON.parse(storedMeta));
        }
        
        const updatedData = data.data.result.map((item) => 
        {
          if(item.region_id){
            const regionFound =  metaData[0]?.meta_data?.regions.find((findItem) => findItem.region_id === item.region_id)
            if(regionFound){
              item.regionName = regionFound.region;
            }
          }
          return item;
        });
        setPricingModel(updatedData);
        setIsLoading(false);
    }
    catch (error) {
      setIsLoading(false);
        console.log("error while fetching data", error);
    }
  },[metaData]);

  useEffect(() => {
    if(metaData.length > 0){
      fetchPricingList();
    }
  },[metaData, fetchPricingList]);


  const editPricingModel = useCallback((data) => {
    history.push("/create-pricing-page", data);
  }, [history]);

  const handleDelete = useCallback(async (item) => {
    if (window.confirm("Are you sure you want to delete this Pricing Model?")) {
      setIsLoading(true);
      try {
        await deletePricingModelCall({}, {}, item);
        ShowToast('Pricing Model deleted successfully', TYPE_SUCCESS, INTERVAL, "", "");
        await fetchPricingList();
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        ShowToast('Something went wrong. Please delete again after some time!', TYPE_FAIL, INTERVAL, "", "");
      }
    }
  },[fetchPricingList]);

  useEffect(() => {
    const tableActions = () => {
      let tableActions = [];
      if (hasPermission("pricing_model", "update")) {
        tableActions.push({
          icon: () => <i className={`${EDIT_ICON}`} title="Edit Procing Model"></i>,
          onClick: (event, rowData) => editPricingModel(rowData)
        })
      }
      if (hasPermission("pricing_model", "delete")) {
        tableActions.push({
          icon: () => <i className={`${TRASH_ICON}`} title="Delete Pricing Model"></i>,
          onClick: (event, rowData) => handleDelete(rowData.pricingId)
        });
      }
      setTableActionsArray(tableActions);
    }
    tableActions();
  }, [editPricingModel, handleDelete])

  const createPricingModel = () => {
      window.location.href = "/create-pricing-page";
  }

  const mytheme= createTheme({});
  return (<>
    {
      isLoading === true ? (
        <Spinner />
        ) : 
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${ACCOUNT_ICON}`}></i> Pricing Model</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
            {
              hasPermission("pricing_model", "create") && (
                <div className="form-button-div">
                  <button className="brand-button" onClick={createPricingModel}>Create</button>
                </div>
              )
            }
            <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
                {
                    true ? (
                        <ThemeProvider theme={mytheme}>
                            <MaterialTable
                                columns={[
                                    {
                                        title: "Region Name", field: "regionName",
                                        cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "Module", field: "module",
                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                    },
                                    {
                                        title: "Credits Required", field: "creditsRequired",
                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                    },
                                ].filter(Boolean)}
                                data={
                                    pricingModel.map((item) => {
                                      return (
                                        {
                                          pricingId: item._id,
                                          regionId: item.region_id,
                                          regionName: item.regionName,
                                          module: item.module,
                                          creditsRequired: item.credits,
                                        }
                                      )
                                    })
                                }
                                actions={tableActionsArray}
                                options={{
                                    actionsColumnIndex: -1,
                                    headerStyle: {
                                        color: '#999998',
                                        fontWeight: 'bolder',
                                        fontSize: 15
                                    },
                                    filtering: true,
                                    sorting: true,
                                    columnsButton: true,
                                    exportButton: true,
                                    exportFileName: "Pricing Page Data"
                                }}
                            />
                        </ThemeProvider>
                    ) : (
                        <div className="text-center pt-2">
                            <label>Not Found</label>
                        </div>
                    )
                }
            </div>
          </div>
        </div>
      )
    }
  </>);
};

export default PricingModelPage;
